import api from "./api"; 

const VehicleTransferRequestService = {
  create: async (data) => {
    const response = await api.post("/vehicleTransferRequest/save", data);
    return response.data;
  },

  getAll: async () => {
    const response = await api.get("/vehicleTransferRequest/getAll");
    return response.data.data || response.data;
  },

  getActive: async () => {
    const response = await api.get("/vehicleTransferRequest/getActive");
    return response.data.data || response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/vehicleTransferRequest/getById/${id}`);
    return response.data.data || response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/vehicleTransferRequest/update/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/vehicleTransferRequest/${id}`);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/vehicleTransferRequest/updateStatus/${id}`, { status });
    return response.data;
  },
  
  acceptRequest: async (id, employeeId) => {
    const res = await api.put(`/vehicleTransferRequest/accept/${id}`, {
      employeeId,
    });
    return res.data;
  },

  rejectRequest: async (id, employeeId) => {
    const res = await api.put(`/vehicleTransferRequest/reject/${id}`, {
      employeeId,
    });
    return res.data;
  },
};

export default VehicleTransferRequestService;
